import Vue from 'vue';
export default Vue.extend({
    name: 'KlookLikeMobileMenuBody',
    props: {
        /* control drawer from parent */
        isOpen: { type: Boolean, default: false },
        showOverlay: { type: Boolean, default: true },
        emitOpenAuthModal: {
            type: Function,
            default: () => { }
        },
        emitGoToAccount: {
            type: Function,
            default: () => { }
        },
        menuCategories: {
            type: Array,
            default: () => []
        },
        isLoggedIn: {
            type: Boolean,
            default: false
        },
        showHeader: { type: Boolean, default: true },
        showSearch: { type: Boolean, default: true },
        rootColumns: { type: Number, default: 1 } // tile columns on root
    },
    data() {
        return {
            stack: [],
            query: ''
        };
    },
    computed: {
        depth() { return this.stack.length; },
        currentNode() { return this.stack[this.stack.length - 1] || null; },
        currentTitle() { return this.currentNode ? this.currentNode.title : ''; },
        currentChildren() {
            if (!this.currentNode)
                return [];
            return (this.currentNode.children || []);
        },
        gridStyle() {
            return { gridTemplateColumns: `repeat(${this.rootColumns}, 1fr)` };
        }
    },
    mounted() {
        // dvh fallback var to avoid bottom toolbar overlap
        this.setViewportVar();
        window.addEventListener('resize', this.setViewportVar, { passive: true });
        if (window.visualViewport) {
            window.visualViewport.addEventListener('resize', this.setViewportVar, { passive: true });
            window.visualViewport.addEventListener('scroll', this.setViewportVar, { passive: true });
        }
        // close on Esc
        document.addEventListener('keydown', this.onKeydown);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setViewportVar);
        if (window.visualViewport) {
            window.visualViewport.removeEventListener('resize', this.setViewportVar);
            window.visualViewport.removeEventListener('scroll', this.setViewportVar);
        }
        document.removeEventListener('keydown', this.onKeydown);
    },
    methods: {
        onKeydown(e) {
            if (e.key === 'Escape' && this.isOpen)
                this.$emit('close');
        },
        setViewportVar() {
            const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
            document.documentElement.style.setProperty('--mm-vh', `${vh * 0.01}px`);
        },
        openAuthModal() { this.$emit('emitOpenAuthModal'); },
        goToAccount() { this.$emit('emitGoToAccount'); },
        openCategory(cat) { this.stack = [cat]; },
        openChild(item) { this.stack = [...this.stack, item]; },
        goBack() { this.stack = this.stack.slice(0, -1); },
        filtered(items) {
            if (!this.query)
                return items;
            const q = this.query.toLowerCase();
            return items.filter(x => x.title.toLowerCase().includes(q));
        }
    }
});
